module.exports = __webpack_public_path__ + "media/character-dog-content.3bbcf9a1.mp3";